import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../Wrapper.vue';
import BlacklistContainer from './BlacklistContainer.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/blacklist'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_blacklist',
          component: BlacklistContainer,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
